import { useQuery } from '@tanstack/react-query'
import { MINUTE_IN_MS } from '@/modules/shared/constants/time'
import { getHistoricalFiles } from './getHistoricalFiles'
import { HistoricalFileGroupDto } from './types'

type Props = {
  companyId: string
  dateFrom: string
  dateTo: string
  isDriver: boolean
  enabled?: boolean
}

const QUERY_KEY_HISTORICAL_FILES = 'QUERY_KEY_HISTORICAL_FILES'

export function useQueryHistoricalFiles(props: Props) {
  const { companyId, dateFrom, dateTo, isDriver, enabled = true } = props
  return useQuery<HistoricalFileGroupDto[]>({
    queryKey: [QUERY_KEY_HISTORICAL_FILES, companyId, dateFrom, dateTo, isDriver],
    queryFn: async () => {
      const { data } = await getHistoricalFiles({ companyId, dateFrom, dateTo, isDriver })
      return data ?? []
    },
    staleTime: MINUTE_IN_MS * 5,
    enabled: Boolean(companyId) && enabled,
  })
}
